import React, { useState } from "react";

import { Link } from "react-router-dom";
import { HiOutlineExternalLink } from "react-icons/hi";
import "./maincontent.css";
import { linksConfig } from "../../linksConfig";

async function loadpdffile(accessToken){
 try {
  if(accessToken ===''){console.log('access token not obtained!')}
  var headers = new Headers();
  var bearer = "Bearer "+accessToken;
  headers.append("Authorization",bearer);
  var options={method:"GET",headers:headers};
    await fetch(`${linksConfig.link.apilink}/SecurityMatrix`,options).then((response)=> response.blob().then((blob)=>{
      const fileurl = window.URL.createObjectURL(blob);
      let alink =document.createElement('a');
      alink.href = fileurl;
      alink.download =`SecurityMatrix.pdf`
      alink.click();
    }
    ))
 }
 catch (error){
  console.log(error)
  return('error');
 }
}

const Maincontent = (Props) => {

  // const [checkerflag,setCheckerFlag] = useState(['']); 
  return (
    <div className="secnav__maincon">
      <p>
        With so many security and data protection guidelines it's hard to keep
        focus on what's important or needed.
      </p>
      <h3>SecNav helps you find answers to …</h3>
      <ul>
        <li>which security & privacy measures are mandatory</li>
        <li>when they have to be processed</li>
        <li>how to apply them</li>
      </ul>
      <div className="secnav__maincon__buttonsdiv">
        {/* <div className="secnav__maincon__buttonsdiv__link01">
          <div>Start Secnav</div>
          <div>
            <HiOutlineExternalLink />
          </div>
        </div> */}
        
          <div className="secnav__maincon__buttonsdiv__link02">
          <Link
          to="/allmeasures"
          style={{ textDecoration: "none", fontSize: "18px", color: "white" }}>All Measures
            </Link>
            <div>
            <HiOutlineExternalLink />
            </div>
          </div>
       

        {/* <div className="secnav__maincon__buttonsdiv__link03">
          <div
            onClick={()=> loadpdffile(Props.accessToken)}
          >
            Security Matrix
          </div>
          <div>
            <HiOutlineExternalLink />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Maincontent;
